export const addCommasToNumber = num => {
  if (num) {
    return num?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  } else {
    return '0';
  }
};
